import React from 'react';
import ZombiePurgeCheckbox from '../Checkbox';
import Image from 'next/image';

export default function ZombiePurgeListCard({ zombie, isSelected, updateCardSelection, showCheckbox = true }) {
	const [isSelectionTriggered, setIsSelectionTriggered] = React.useState( false );

	return (
		<div 
			onClick={()=>setIsSelectionTriggered( ( prev ) => !prev )}
			className='flex items-center h-auto cursor-pointer w-[45%] max-[768px]:w-[49%] max-[650px]:w-[95%]'>
			{showCheckbox && <ZombiePurgeCheckbox className="mr-3"
				key={isSelectionTriggered}
				isSelected={isSelected}
				triggerClick={isSelectionTriggered}
				onClick={()=>updateCardSelection( zombie.id )} />}
			<Image className={'ml-3 rounded-xl'}
				src={zombie.image}
				width={128}
				height={128}/>
			<div>
				<h2 className="m-0 p-0 ml-3 mb-2 text-3xl leading-1 max-[768px]:text-xl">{zombie.title}</h2>
				{zombie.purgedAt && <p className="mb-1 mt-1 p-0 ml-3 max-[768px]:text-xs">
					Purged: &nbsp; 
					{zombie.purgedAt}
				</p>}
				<p className="m-0 p-0 ml-3 max-[768px]:text-xs">by Rare Apepes</p>
			</div>

		</div>
	);
}
